// ============================================================
//  src/data/products.js
//  ✅ ADD / EDIT / REMOVE products here
//
//  IMAGES: Place all product images in /public/images/
//  The `image` field should match the filename exactly.
//  If the image is missing, the `emoji` is shown as fallback.
// ============================================================

const products = [
  {
    id: 1,
    name: "Organic Finger Millet",
    price: 65,
    prices: {"500g": 65, "1kg": 130 },  
    rating: 5.0,
    reviews: 12,
    category: "Millets",
    badge: "Organic",
    color: "#c0392b",
    emoji: "🌾",
    image: "/images/finger-millet.jpeg",   // file: public/images/finger-millet.jpeg
    weight: "500g",
    origin: "Nilgiris, Tamil Nadu",
    description: "Stone-ground organic ragi from the Nilgiris. Rich in calcium, iron and dietary fibre. Cold-pressed to retain maximum nutrients.",
    inStock: true,
    sizes: ["500g", "1kg"],
    vegNonVeg: "Veg",
    shelfLife: "6 Months",
    netQuantity: "1",
    storageInstructions: "Store in a cool and dry place. Keep airtight after opening.",
    highlights: [
      "Rich in Calcium & Iron",
      "Gluten Free Grain",
      "Stone-ground, cold-pressed",
      "No preservatives or additives",
      "Good source of dietary fibre",
    ],
    nutritionPer100g: {
      Energy: "336 kcal", Protein: "7.3 g", Carbohydrates: "72.0 g",
      Sugars: "0.6 g", "Total Fat": "1.5 g", "Dietary Fibre": "3.6 g",
      Iron: "3.9 mg", Calcium: "344 mg",
    },
  },
  {
    id: 2,
    name: "Black Rice",
    price: 180,
    prices: { "500g": 180, "1kg": 360 },
    rating: 5.0,
    reviews: 8,
    category: "Traditional Rice",
    badge: "Organic",
    color: "#2c3e50",
    emoji: "🍚",
    image: "/images/black-rice.jpeg",      // file: public/images/black-rice.jpeg
    weight: "500g",
    origin: "Manipur",
    description: "Heirloom Manipuri black rice packed with antioxidants. Nutty flavour and beautiful purple hue when cooked.",
    inStock: true,
    sizes: ["500g", "1kg"],
    vegNonVeg: "Veg",
    shelfLife: "12 Months",
    netQuantity: "1",
    storageInstructions: "Store in an airtight container in a cool, dry place away from sunlight.",
    highlights: [
      "Rich in Antioxidants (Anthocyanins)",
      "High in Protein & Fibre",
      "Heirloom variety from Manipur",
      "No polishing or bleaching",
      "Natural purple colour when cooked",
    ],
    nutritionPer100g: {
      Energy: "353 kcal", Protein: "8.9 g", Carbohydrates: "74.9 g",
      Sugars: "0.5 g", "Total Fat": "3.5 g", "Dietary Fibre": "4.9 g",
      Iron: "3.5 mg", Calcium: "27 mg",
    },
  },
  {
    id: 3,
    name: "Jaggery Powder",
    price: 65,
    prices: { "500g": 65, "1kg": 130 },
    rating: 5.0,
    reviews: 15,
    category: "Sweeteners",
    badge: "Best Seller",
    color: "#d4830a",
    emoji: "🍯",
    image: "/images/jaggery-powder.jpeg",  // file: public/images/jaggery-powder.jpeg
    weight: "500g",
    origin: "Namakkal, Tamil Nadu",
    description: "Traditional Kolhapur jaggery powder, sun-dried and unrefined. Naturally sweet with rich mineral content.",
    inStock: true,
    sizes: ["500g", "1kg"],
    vegNonVeg: "Veg",
    shelfLife: "9 Months",
    netQuantity: "1",
    storageInstructions: "Store in a dry place. Avoid moisture. Use a dry spoon.",
    highlights: [
      "Unrefined & unprocessed",
      "Rich in Iron & Potassium",
      "Natural alternative to white sugar",
      "Sun-dried Kolhapur sugarcane",
      "No chemical additives",
    ],
    nutritionPer100g: {
      Energy: "383 kcal", Protein: "0.4 g", Carbohydrates: "98.0 g",
      Sugars: "95.0 g", "Total Fat": "0.1 g",
      Iron: "11 mg", Calcium: "80 mg", Potassium: "140 mg",
    },
  },
  {
    id: 4,
    name: "Tasty Bajra (Pearl Millet)",
    price: 75,
    prices: { "500g": 75, "1kg": 186 },
    rating: 5.0,
    reviews: 6,
    category: "Millets",
    badge: "New",
    color: "#7f8c8d",
    emoji: "🌿",
    image: "/images/bajra.jpeg",           // file: public/images/bajra.jpeg
    weight: "500g",
    origin: "Rajasthan",
    description: "Whole pearl millet grains from Rajasthan. High in protein and perfect for rotis, porridge and khichdi.",
    inStock: true,
    sizes: ["500g", "1kg"],
    vegNonVeg: "Veg",
    shelfLife: "6 Months",
    netQuantity: "1",
    storageInstructions: "Store in a cool, dry place in an airtight container.",
    highlights: [
      "High in Protein",
      "Rich in Magnesium & Phosphorus",
      "Good for heart health",
      "Gluten-free whole grain",
      "Ideal for rotis & porridge",
    ],
    nutritionPer100g: {
      Energy: "361 kcal", Protein: "11.6 g", Carbohydrates: "67.0 g",
      Sugars: "1.5 g", "Total Fat": "5.0 g", "Dietary Fibre": "1.2 g",
      Iron: "8.0 mg", Calcium: "42 mg",
    },
  },
  {
    id: 5,
    name: "Foxtail Millet",
    price: 65,
    prices: { "500g": 65, "1kg": 130 },
    rating: 5.0,
    reviews: 9,
    category: "Millets",
    badge: "Gluten Free",
    color: "#27ae60",
    emoji: "✨",
    image: "/images/Foxtail-millet.jpeg", // image not available in public/images — fallback to emoji
    weight: "500g",
    origin: "Uttarakhand",
    description: "White quinoa sourced from high-altitude Uttarakhand farms. Complete protein, gluten-free superfood.",
    inStock: true,
    sizes: ["500g", "1kg"],
    vegNonVeg: "Veg",
    shelfLife: "12 Months",
    netQuantity: "1",
    storageInstructions: "Store in an airtight container in a cool, dry place.",
    highlights: [
      "Complete protein — all 9 essential amino acids",
      "Gluten-free superfood",
      "High in Magnesium & Folate",
      "Low glycemic index",
      "Organic certified",
    ],
    nutritionPer100g: {
      Energy: "350 kcal", Protein: "11 g", Carbohydrates: "65 g",
      Sugars: "2 g", "Dietary Fibre": "8 g",
      Iron: "4 mg", Calcium: "12 mg",
    },
  },
  {
    id: 6,
    name: "Cashews 320 Grade",
    price: 250,
    prices: { "250g": 250, "500g": 500, "1kg": 1000 },
    rating: 5.0,
    reviews: 20,
    category: "Dry Fruits & Nuts",
    badge: "Best Seller",
    color: "#f39c12",
    emoji: "🥜",
    image: "/images/cashews.jpeg", // image not available in public/images — fallback to emoji
    weight: "250g",
    origin: "Goa",
    description: "Premium W320 grade cashews from Goa. Creamy, buttery texture. No preservatives, no added salt.",
    inStock: true,
    sizes: ["250g", "500g", "1kg"],
    vegNonVeg: "Veg",
    shelfLife: "6 Months",
    netQuantity: "1",
    storageInstructions: "Store in a cool, dry place. Refrigerate after opening for longer freshness.",
    highlights: [
      "Premium W320 Grade",
      "No preservatives or added salt",
      "Rich in Healthy Fats & Protein",
      "Source of Zinc & Magnesium",
      "Hand-sorted & naturally dried",
    ],
    nutritionPer100g: {
      Energy: "553 kcal", Protein: "18.2 g", Carbohydrates: "30.2 g",
      Sugars: "5.9 g", "Total Fat": "43.8 g", "Dietary Fibre": "3.3 g",
      Iron: "6.7 mg", Calcium: "37 mg",
    },
  },
  {
    id: 7,
    name: "Kodo Millet",
    price: 75,
    prices: { "500g": 75, "1kg": 150 },
    rating: 5.0,
    reviews: 11,
    category: "Millets",
    badge: "Gluten Free",
    color: "#8e44ad",
    emoji: "🌱",
    image: "/images/Kodo-millet.jpeg", // image not available in public/images — fallback to emoji
    weight: "500g",
    origin: "Karnataka",
    description: "Ancient grain jowar flour, stone-milled fresh. Excellent for diabetics, high in protein and fibre.",
    inStock: true,
    sizes: ["500g", "1kg"],
    vegNonVeg: "Veg",
    shelfLife: "6 Months",
    netQuantity: "1",
    storageInstructions: "Store in an airtight container in a cool, dry place away from humidity.",
    highlights: [
      "Stone-milled fresh to order",
      "Gluten-free ancient grain",
      "Low glycemic index — great for diabetics",
      "High in Protein & B-Vitamins",
      "No artificial additives",
    ],
    nutritionPer100g: {
      Energy: "353 kcal", Protein: "8.3 g", Carbohydrates: "66 g",
      Sugars: "1.5 g", "Total Fat": "3.6 g", "Dietary Fibre": "9 g",
      Iron: "1.7 mg", Calcium: "27 mg",
    },
  },
];

export default products;

export const categories = ["All", ...new Set(products.map((p) => p.category))];
